import { createContext, useContext } from 'react'
import type { HandledContest } from 'src/components/Contest/useContestConfig'

export interface ArtworkListPageContext {
  selectedContestTag?: HandledContest
  insertCampaignAdUnit?: boolean
}

export const ArtworkListPageContext = createContext<ArtworkListPageContext>({})

export const useArtworkListPageContext = () =>
  useContext(ArtworkListPageContext)
